<template>
  <div class="col-xl-4">
    <h5 slot="header" class="h3 mb-0">Tasks</h5>
    <ul class="list-group list-group-flush" data-toggle="checklist">
      <li class="list-group-item px-0">
        <div
          :class="{
            'checklist-item-checked': serviceRequest.customerCall,
            [`checklist-item-success`]: 'success'
          }"
          class="checklist-item"
        >
          <div class="checklist-info">
            <h5 class="checklist-title mb-0">Call To Customer</h5>
            <small v-if="serviceRequest.users">{{
              serviceRequest.users.phone
            }}</small>
            <br />
          </div>
          <div>
            <base-checkbox
              v-model="serviceRequest.customerCall"
              v-on:change="handleCallEvent()"
              :disabled="parseInt(serviceRequest.currentStep) >= 1"
              type="success"
            />
          </div>
        </div>
      </li>
      <li class="list-group-item px-0">
        <div
          :class="{
            'checklist-item-checked': serviceRequest.isSiteVisited,
            [`checklist-item-warning`]: 'warning'
          }"
          class="checklist-item"
        >
          <div class="checklist-info">
            <h5 class="checklist-title mb-0">Site Visit</h5>
            <small v-if="serviceRequest.users">{{
              serviceRequest.users.locality
            }}</small>
            <br />
          </div>
          <div>
            <base-checkbox
              v-model="serviceRequest.isSiteVisited"
              v-on:change="handleVisitEvent()"
              :disabled="parseInt(serviceRequest.currentStep) >= 1"
              type="warning"
            />
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      items: [
        {
          title: "Call to Customer",
          description: "+917030984869",
          done: false,
          checkType: "success",
          note: ""
        },
        {
          title: "Visit Site",
          description: "A407 Sai Leela Apartment,Niwas Road, Aundh",
          done: false,
          checkType: "warning",
          note: ""
        }
      ]
    };
  },
  computed: {
    ...mapState("serviceRequest", ["serviceRequest"])
  },
  async mounted() {
    await this.fetchServiceRequest(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      updateServiceRequestData: "serviceRequest/updateServiceRequestData"
    }),
    handleCallEvent() {
      this.updateServiceRequestData({
        serviceRequestId: this.serviceRequest.serviceRequestId,
        customerCall: this.serviceRequest.customerCall
      });
    },
    handleVisitEvent() {
      this.updateServiceRequestData({
        serviceRequestId: this.serviceRequest.serviceRequestId,
        isSiteVisited: this.serviceRequest.isSiteVisited
      });
    }
  }
};
</script>
<style>
.checklist-info input {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #9e9e9e;
  border-radius: 0;
  outline: none;
  height: 3rem;
  width: 100%;
  font-size: 14px;
  margin: 0 0 8px 0;
  padding: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-transition: border 0.3s, -webkit-box-shadow 0.3s;
  transition: border 0.3s, -webkit-box-shadow 0.3s;
  transition: box-shadow 0.3s, border 0.3s;
  transition: box-shadow 0.3s, border 0.3s, -webkit-box-shadow 0.3s;
}
</style>
